import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { FormattedMessage as Translation } from 'react-intl';
import CTA from "../../../Components/CTA/CTA";
import useValuationResult from "./../useValuationResults";
var css = {
  "bookAnAppointment": "oalp-2UeWd",
  "imageContainer": "oalp-1RyFp",
  "imageContainer__img": "oalp-3QQ4g",
  "priceContent": "oalp-3GqgR",
  "priceContent__truePrice": "oalp-_Kyyr",
  "priceContent__priceRange": "oalp-3LCQa",
  "priceContent__description": "oalp-1pyIp",
  "priceContent__condition": "oalp-1s3ul",
  "bookBtn": "oalp-2xhnZ",
  "revalBtn": "oalp-5ER8P"
};
import ImageWrapper from "../../../Components/ImageWrapper/ImageWrapper";
export var BookAnAppointmentR1 = function BookAnAppointmentR1(_ref) {
  var name = _ref.name,
    _ref$data = _ref.data,
    _ref$data$cta = _ref$data.cta,
    _ref$data$cta$buttons = _ref$data$cta.buttons,
    _ref$data$cta$buttons2 = _ref$data$cta$buttons === void 0 ? [] : _ref$data$cta$buttons,
    _ref$data$cta$buttons3 = _slicedToArray(_ref$data$cta$buttons2, 1),
    primaryBtn = _ref$data$cta$buttons3[0],
    revaluate = _ref$data$cta.revaluate,
    image = _ref$data.image,
    _ref$data$description = _ref$data.descriptionText,
    _ref$data$description2 = _ref$data$description === void 0 ? {} : _ref$data$description,
    descriptionText = _ref$data$description2.text,
    style = _ref$data$description2.style,
    metadata = _ref.metadata;
  var _ref2 = metadata || {},
    widgetStyle = _ref2.style;
  var _useValuationResult = useValuationResult(),
    displayName = _useValuationResult.displayName,
    maxPrice = _useValuationResult.maxPrice,
    minPrice = _useValuationResult.minPrice,
    selectedConditionText = _useValuationResult.selectedConditionText;
  return /*#__PURE__*/React.createElement("div", {
    className: css.bookAnAppointment,
    style: widgetStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: css.imageContainer
  }, /*#__PURE__*/React.createElement(ImageWrapper, {
    image: image,
    className: css.imageContainer__img
  })), /*#__PURE__*/React.createElement("div", {
    className: css.priceContent
  }, /*#__PURE__*/React.createElement("div", {
    className: css.priceContent__truePrice
  }, /*#__PURE__*/React.createElement(Translation, {
    id: "true_market_price"
  })), /*#__PURE__*/React.createElement("div", {
    className: css.priceContent__priceRange
  }, minPrice, " - ", maxPrice), /*#__PURE__*/React.createElement("div", {
    className: css.priceContent__description,
    style: style
  }, descriptionText, " "), /*#__PURE__*/React.createElement("div", {
    className: css.priceContent__condition
  }, displayName, " in ", selectedConditionText)), /*#__PURE__*/React.createElement(CTA, {
    button: primaryBtn,
    widgetKey: name,
    customClass: css.bookBtn
  }), revaluate && /*#__PURE__*/React.createElement(CTA, {
    button: revaluate,
    widgetKey: name,
    customClass: css.revalBtn
  }));
};
export default /*#__PURE__*/React.memo(BookAnAppointmentR1);